import { Component, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ErrorDialogComponent>,private route: ActivatedRoute,private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: { message: string }
      ) {}
    
      onClose(): void {
        this.dialogRef.close();
        this.route.queryParams.subscribe(params => {
            const idParam = params['id'];
            const emailParam = params['email'];
            this.router.navigate(['register', 'login'], {
              queryParams: { id: idParam, email: emailParam }
            });
          });
      }
}
